import * as React from 'react';
import { useLink, useLocation } from '@grandvisionhq/frk-routing';
import '@swc/helpers';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import { appendQueryParamToUrl } from '../../utils/get-updated-url-with-query-params.js';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import 'history';
import '../../utils/has-cart-errors.js';

const useRedirectToExpressCheckout = ()=>{
    const { href: expressCheckoutHref  } = useLink({
        route: 'express-checkout',
        params: {
            type: 'APPLE_PAY',
            cartId: ''
        }
    }) || {};
    const { replace  } = useLocation();
    /**
   * @description  redirect to /express-checkout page with query params
   * @argument param json of query parameter key & value
   */ const redirectToExpressCheckout = React.useCallback((param)=>{
        if (expressCheckoutHref) {
            replace(appendQueryParamToUrl(expressCheckoutHref, param));
        } else {
            throw Error('Failed redirection to /order/confirm. Route not found');
        }
    }, [
        expressCheckoutHref,
        replace
    ]);
    return redirectToExpressCheckout;
};

export { useRedirectToExpressCheckout };
//# sourceMappingURL=use-redirect-to-express-checkout.js.map
